import React from 'react'
import './header.css'
import people from '../../assets/people.png'
import ai from '../../assets/ai.png'
import { motion, useScroll, AnimatePresence, useTransform } from "framer-motion";



const Header = () => {
    const { scrollYProgress } = useScroll();
    let left = useTransform(scrollYProgress, [0, .4], [0, -400]);
    let right = useTransform(scrollYProgress, [0, .4], [0, 300]);


    return (
        <AnimatePresence>
            <div className='gpt3__header section__padding' id="home">
                <div className='gpt3__header-content'>
                    <motion.div
                        style={{ x: left }}
                    >
                        <motion.h1 initial={{ x: -50, opacity: 0 }}

                            animate={{ x: 0, opacity: 1 }}
                            transition={{ ease: "easeOut", duration: 4, type: "spring", }}
                            className='gradient__text'>
                            Let's Build Something amazing with GPT3 OpenAi
                        </motion.h1>
                    </motion.div>
                    <motion.p
                        initial={{ x: 50, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        transition={{ ease: "easeOut", duration: 2, type: "spring", }}>
                        Yet bed any for travelling assistance indulgence unpleasing. Not thoughts all exercise blessing. Indulgence way everything joy alteration boisterous the attachment. Party we years to order allow asked of.
                    </motion.p>
                    <div className='gpt3__header-content__input'>
                        <input type="email" placeholder="please enter email" />
                        <button type="button">Get Started</button>
                    </div>
                    <div className='gpt3__header-content__people'>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{
                                duration: 4,
                                delay: 0.4,
                                ease: [0, 0.71, 0.2, 1.01]
                            }}
                        >
                            <img src={people} alt="people" />
                        </motion.div>
                        <p>1,600 people requested access a visit in last 24 hours</p>
                    </div>
                </div>
                <div className='gpt3__header-image'>
                    <motion.img src={ai} alt="ai"
                        style={{ x: right }}
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{
                            type: "spring",
                            stiffness: 400, damping: 67,
                            duration: 4,
                            ease: "easeOut"
                        }}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                    />

                </div>
            </div>
        </AnimatePresence>
    )
}

export default Header